import React from 'react';
import { Helpers, Providers } from "@tpd-web-common-libs/nodejs-library";
import PageLayout from "../page-layouts/PageLayout";
import EditModeToggle from "./EditModeToggle";
import HeadTags from "./HeadTags";
import { EndingBodyScripts } from "./script-tags/EndingBodyScripts";
import { useEffect, useRef } from "react";
import { PageDataLayer } from "./PageDataLayer";

export default function RemotePage(props: Providers.PageLayouts.TNextPage) {
  const lastPagePropsHash = useRef<string | null>(null);

  useEffect(() => {
    const pagePropsHash = JSON.stringify(props);

    if (lastPagePropsHash.current === pagePropsHash) {
      //evita doppie anaylics dovute a re-render client-server
      return;
    }

    lastPagePropsHash.current = pagePropsHash;

    const routerService = Providers.RouterService.getInstance();
    routerService.onRouteChangeComplete(props);

    return () => {
      // do nothing
    };
  }, [props.url, props]);
  return (
    <div className="mfe-page-container" data-build-timestamp={props.buildTimestamp}>
      <HeadTags {...props} />
      <PageDataLayer />
      <PageLayout {...props} />
      <EndingBodyScripts />
      {Helpers.EnvironmentHelper.isLocalEnvironment() && <EditModeToggle />}
    </div>
  );
}
